import { Box, Stack } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useTenant } from "hooks/settings";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";
import { useLocalDatetime } from "hooks/useLocalDateTime";
import { loadedEndpoint } from "models/loaded";
import { useMemo, useState } from "react";
import { useGetStrategyDashboardDeliveriesOverviewQuery } from "src/store/api/generatedApi";
import { MonthStepper } from "../common/MonthStepper";
import { DeliveryPaceTable } from "./DeliveryPaceTable";
import {
  getCurrentCalendarMonth,
  toLocalCalendarTime,
} from "src/utils/toLocalCalendarTime";

export const DeliveriesPaceOverview = () => {
  const tenantName = useTenant();
  const { localTimezone } = useLocalDatetime();
  const showPacePercent = useIsBehindFeatureFlag(
    "strategy_dashboard_delivery_pace_percent"
  );

  const [selectedMonth, setSelectedMonth] = useState<Dayjs>(() =>
    getCurrentCalendarMonth(localTimezone)
  );

  const currentMonth = getCurrentCalendarMonth(localTimezone);
  const isCurrentMonth = selectedMonth.isSame(currentMonth, "month");

  const on = useMemo(() => {
    const targetDate = isCurrentMonth
      ? toLocalCalendarTime(dayjs(), localTimezone)
      : selectedMonth.endOf("month");
    // The backend reads only on.date(); pin to midday UTC so the tenant-local
    // calendar date can't roll to an adjacent day when serialised to UTC.
    return `${targetDate.format("YYYY-MM-DD")}T12:00:00.000Z`;
  }, [isCurrentMonth, selectedMonth, localTimezone]);

  const loadedData = loadedEndpoint(
    useGetStrategyDashboardDeliveriesOverviewQuery({ tenantName, on })
  );

  return (
    <Stack spacing={2}>
      <MonthStepper
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
      />
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Box sx={{ width: "70%" }}>
          <DeliveryPaceTable
            loadedData={loadedData}
            showPacePercent={showPacePercent}
            showRemainingMass
          />
        </Box>
      </Box>
    </Stack>
  );
};
